import Modal from "components/modals/TestModal";
import Button from "features/newLanding/Button/Button";

const AccountTypeModal = ({ open, setOpen, setType, type, onClick, token }) => {
  const handleSetType = (type) => {
    setType(type);
  };

  const borderStyle = (accType) =>
    type === accType ? "2px solid #6C63FF" : "2px solid #f8f7ff";
  return (
    <Modal
      show={open}
      position="bottom"
      isEcomm={true}
      onClose={() => {
        setOpen(false);
        setType(null);
      }}
    >
      <div className="px-5 pb-5">
        <p className="text-lg font-medium pb-[30px]">
          Select your account type
        </p>
        <div className="flex flex-col gap-5 ">
          <div
            className="bg-[#f8f7ff] cursor-pointer flex gap-5 rounded-2xl px-5 py-[15px]"
            onClick={() => handleSetType("INDIVIDUAL")}
            style={{
              border: borderStyle("INDIVIDUAL"),
            }}
          >
            <div>
              <svg
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M36.2 25.8C37.473 25.8 38.6939 26.3057 39.5941 27.2059C40.4943 28.1061 41 29.327 41 30.6V32.2C41 38.508 35.05 45 25 45C14.95 45 9 38.508 9 32.2V30.6C9 29.327 9.50571 28.1061 10.4059 27.2059C11.3061 26.3057 12.527 25.8 13.8 25.8H36.2ZM36.2 29H13.8C13.3757 29 12.9687 29.1686 12.6686 29.4686C12.3686 29.7687 12.2 30.1757 12.2 30.6V32.2C12.2 36.8 16.782 41.8 25 41.8C33.218 41.8 37.8 36.8 37.8 32.2V30.6C37.8 30.1757 37.6314 29.7687 37.3314 29.4686C37.0313 29.1686 36.6243 29 36.2 29ZM25 5C26.7405 5 28.4419 5.51611 29.889 6.48307C31.3362 7.45002 32.4641 8.8244 33.1301 10.4324C33.7962 12.0404 33.9705 13.8098 33.6309 15.5168C33.2914 17.2238 32.4532 18.7918 31.2225 20.0225C29.9918 21.2532 28.4238 22.0914 26.7168 22.4309C25.0098 22.7705 23.2404 22.5962 21.6324 21.9301C20.0244 21.2641 18.65 20.1362 17.6831 18.689C16.7161 17.2419 16.2 15.5405 16.2 13.8C16.2 11.4661 17.1271 9.22778 18.7775 7.57746C20.4278 5.92714 22.6661 5 25 5ZM25 8.2C23.8924 8.2 22.8097 8.52843 21.8888 9.14377C20.9679 9.75911 20.2501 10.6337 19.8263 11.657C19.4024 12.6802 19.2915 13.8062 19.5076 14.8925C19.7237 15.9788 20.257 16.9766 21.0402 17.7598C21.8234 18.543 22.8212 19.0763 23.9075 19.2924C24.9938 19.5085 26.1198 19.3976 27.143 18.9737C28.1663 18.5499 29.0409 17.8321 29.6562 16.9112C30.2716 15.9903 30.6 14.9076 30.6 13.8C30.6 12.3148 30.01 10.8904 28.9598 9.8402C27.9096 8.79 26.4852 8.2 25 8.2Z"
                  fill="#170738"
                />
              </svg>
            </div>
            <div>
              <p className="font-bold text-xl">Individual</p>
              <p className="text-[#9682be] text-sm">Physical persons</p>
            </div>
          </div>
          <div
            className="bg-[#f8f7ff]  cursor-pointer  flex gap-5 rounded-2xl px-5 py-[15px]"
            onClick={() => handleSetType("BUSINESS")}
            style={{
              border: borderStyle("BUSINESS"),
            }}
          >
            <div>
              <svg
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M40.7583 15.1033V9.82664C40.7583 9.65242 40.724 9.4799 40.6573 9.31895C40.5906 9.15799 40.493 9.01175 40.3698 8.88856C40.2466 8.76537 40.1004 8.66766 39.9395 8.60099C39.7786 8.53432 39.6061 8.5 39.432 8.5H11.5631C11.2113 8.5 10.874 8.63977 10.6252 8.88856C10.3765 9.13735 10.2368 9.47479 10.2368 9.82664V15.11C9.90275 15.1325 9.58963 15.2807 9.36024 15.5246C9.13085 15.7685 9.00217 16.0901 9 16.425V21.8575C9.00019 23.3149 9.43041 24.7397 10.2368 25.9535V40.1734C10.2368 40.5252 10.3765 40.8626 10.6252 41.1114C10.874 41.3602 11.2113 41.5 11.5631 41.5H39.4369C39.7887 41.5 40.1261 41.3602 40.3748 41.1114C40.6235 40.8626 40.7632 40.5252 40.7632 40.1734V25.9436C41.0146 25.5672 41.2299 25.168 41.4065 24.7513C41.7988 23.8336 42.0007 22.8457 42 21.8476V16.415C41.9969 16.0799 41.8672 15.7584 41.6368 15.5151C41.4065 15.2718 41.0926 15.1247 40.7583 15.1033ZM13.2127 11.47H37.789V15.1H13.2127V11.47ZM28.1335 38.5317H22.8549V34.2367H28.1335V38.5317ZM37.7824 38.5317H30.7729V32.9183C30.7729 32.5665 30.6331 32.2291 30.3844 31.9803C30.1357 31.7315 29.7983 31.5917 29.4466 31.5917H21.5418C21.1901 31.5917 20.8527 31.7315 20.604 31.9803C20.3553 32.2291 20.2155 32.5665 20.2155 32.9183V38.5317H13.206V28.5421C13.3254 28.6002 13.4497 28.6582 13.5774 28.7079C14.4966 29.0914 15.4827 29.2889 16.4787 29.2889C17.4746 29.2889 18.4607 29.0914 19.3799 28.7079C19.9473 28.4702 20.4835 28.1639 20.9765 27.7959C20.9803 27.7939 20.9846 27.7928 20.9889 27.7928C20.9933 27.7928 20.9975 27.7939 21.0014 27.7959C22.0498 28.5778 23.2838 29.0731 24.5817 29.233C25.8797 29.3929 27.197 29.212 28.4038 28.7079C28.9711 28.4702 29.5073 28.1639 30.0003 27.7959C30.0041 27.7939 30.0084 27.7928 30.0127 27.7928C30.0171 27.7928 30.0213 27.7939 30.0252 27.7959C31.0736 28.5778 32.3076 29.0731 33.6056 29.233C34.9035 29.3929 36.2208 29.212 37.4276 28.7079C37.5519 28.6549 37.6746 28.6002 37.7989 28.5421V38.5317H37.7824ZM39.0192 21.8526C39.0074 22.843 38.6706 23.8022 38.0606 24.5825C37.4507 25.3628 36.6013 25.921 35.6431 26.1713C34.6849 26.4215 33.6711 26.3499 32.7576 25.9675C31.8441 25.5851 31.0815 24.9131 30.5872 24.0548C30.529 23.954 30.4454 23.8704 30.3448 23.8122C30.2441 23.754 30.1299 23.7232 30.0136 23.7231H29.9887C29.8724 23.7232 29.7582 23.754 29.6575 23.8122C29.5568 23.8704 29.4732 23.954 29.4151 24.0548C29.0171 24.7419 28.4455 25.3124 27.7577 25.709C27.0698 26.1056 26.2898 26.3143 25.4959 26.3143C24.7019 26.3143 23.9219 26.1056 23.234 25.709C22.5462 25.3124 21.9746 24.7419 21.5766 24.0548C21.5171 23.9511 21.4312 23.8649 21.3277 23.805C21.2243 23.7451 21.1068 23.7136 20.9873 23.7136C20.8677 23.7136 20.7503 23.7451 20.6468 23.805C20.5433 23.8649 20.4575 23.9511 20.3979 24.0548C19.9025 24.912 19.1393 25.5828 18.2256 25.9639C17.312 26.345 16.2984 26.4154 15.3409 26.1643C14.3833 25.9132 13.5347 25.3544 12.9256 24.5739C12.3164 23.7934 11.9804 22.8344 11.9693 21.8443V18.0833C11.9693 18.078 11.9713 18.0729 11.9751 18.0692C11.9788 18.0655 11.9839 18.0634 11.9891 18.0634H38.9976C39.0029 18.0634 39.0079 18.0655 39.0117 18.0692C39.0154 18.0729 39.0175 18.078 39.0175 18.0833L39.0192 21.8526Z"
                  fill="#170738"
                />
              </svg>
            </div>
            <div>
              <p className="font-bold text-xl">Business</p>
              <p className="text-[#9682be] text-sm">IE / Legal person</p>
            </div>
          </div>
          <Button
            className="bg-primary-main text-white p-5 py-[13px] disabled:bg-[#b6b1ff]"
            onClick={onClick}
            disabled={!type || (type === "INDIVIDUAL" && !token)}
          >
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AccountTypeModal;
